function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(0, 0, 0)','red': 'rgb(237, 28, 36)','green': 'rgb(26, 104, 82)','purple': 'rgb(82, 73, 158)','metallic-gold': 'rgb(219, 195, 81)','opaque-cotton-white': 'rgb(255, 255, 255)','mustard': 'rgb(253, 205, 9)','saddle-brown': 'rgb(192, 142, 44)','timber-brown': 'rgb(84, 57, 47)','pumpkin': 'rgb(232, 107, 44)','blazing-red': 'rgb(139, 23, 56)','black-raspberry': 'rgb(180, 51, 61)','cherry-pink': 'rgb(241, 133, 170)','fuchsia-pink': 'rgb(237, 53, 143)','vibrant-violet': 'rgb(142, 153, 205)','royal-purple': 'rgb(68, 48, 143)','iris': 'rgb(51, 56, 149)','azure': 'rgb(0, 134, 200)','teal-blue': 'rgb(0, 154, 188)','blue': 'rgb(28, 71, 149)','midnight-blue': 'rgb(0, 84, 148)','forest-green': 'rgb(0, 104, 81)','olive-green': 'rgb(101, 115, 50)','cactus-green': 'rgb(140, 196, 63)','eden-green': 'rgb(0, 165, 107)','dove-gray': 'rgb(206, 206, 207)','stone-gray': 'rgb(116, 115, 115)','plum': 'rgb(115, 89, 126)','sepia': 'rgb(161, 75, 0)','metallic-silver': 'rgb(219, 218, 217)','jet-black': 'rgb(0, 0, 0)','metallic-platinum': 'rgb(231, 225, 213)','opaque-mellow-mint': 'rgb(222, 240, 234)','opaque-soft-lilac': 'rgb(195, 186, 220)','black-cherry': 'rgb(182, 52, 62)','opaque-butter-cream': 'rgb(252, 246, 182)',};

    this.images = {'no-ink-pad': 'url("//freshcutprints.com/cdn/shop/files/noinkpad-10_120x.png?v=17745522590956131970")',};

    this.triggers = ['ink color','color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
